import http, {reqDefaultConfig} from "./http";
import {useRequest} from "ahooks";
import cookies from "../utils/cookies";

let apiPath = {
  addShopCar: '/order/orderShopcarDetail/addShopCar',
  subShopCar: '/order/orderShopcarDetail/subShopCar',
  queryShopCar: '/order/orderShopcarDetail/queryShopCar',
  removeShopCar: '/order/orderShopcarDetail/batch/remove',
};
/**
 * 添加商品到购物车
 * @param query
 * @returns {{result: unknown, addHandle: (...params: any[]) => void, loading: boolean, error: Error}}
 */
export const useAddShopCar = (query) => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.addShopCar,
      method: 'post',
      data: query || q
    });
  }, {
    manual: true,
    onSuccess: () => {
      // alert('添加成功');
    },
    ...reqDefaultConfig
  });
  
  return {
    result: data || {},
    loading,
    error,
    addHandle: runAsync,
  };
};

/**
 * 减少 购物车商品sku数量
 * @param query
 * @returns {{result: unknown, subHandle: (...params: any[]) => void, loading: boolean, error: Error}}
 */
export const useSubShopCar = (query) => {
  const { data, run, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.subShopCar,
      method: 'post',
      data: query || q
    });
  }, { manual: true, ...reqDefaultConfig });
  
  return {
    result: data || {},
    loading,
    error,
    subHandle: run,
  };
};

/**
 * 获取购物车列表
 * @returns {{result: unknown, getCart: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useQueryShopCar = () => {
  const { data, runAsync, error, loading } = useRequest(() => {
    // 特殊处理
    if (!cookies.getToken()) return {};
    return http({
      url: apiPath.queryShopCar,
      method: 'get',
      data: {},
    }, {token: false });
  }, {
    manual: true,
    ...reqDefaultConfig
  });
  
  return {
    result: data || {},
    loading,
    error,
    getCart: runAsync,
  };
};

/**
 * 删除购物车商品
 * @param query
 * @param reqConfig
 * @returns {{result: unknown, removeSku: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useRemoveShopCar = (query, reqConfig) => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.removeShopCar,
      method: 'post',
      params: query || q,
    }, { noAlias: true });
    
  }, { ...reqDefaultConfig, manual: true, ...reqConfig });
  
  return {
    result: data || {},
    loading,
    error,
    removeSku: runAsync,
  };
};

